import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/apiClient";
import { Navbar } from "../components/Navbar";

export default function Channels() {
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    api.get("/channels").then((r) => setChannels(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#030305]">
      <Navbar />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-28 md:pt-32 pb-20">
        <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">Browse</p>
        <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tighter mb-12">All Channels</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {channels.map((c, i) => (
            <motion.div
              key={c.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
            >
              <Link
                to={`/channel/${c.slug}`}
                data-testid={`channel-tile-${c.slug}`}
                className="group relative block h-72 overflow-hidden border border-white/10 rounded-sm"
              >
                <img
                  src={c.image}
                  alt={c.name}
                  className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF0000] animate-pulse" />
                  <span className="text-[10px] tracking-[0.2em] uppercase text-zinc-200">Live</span>
                </div>
                <div className="absolute bottom-0 left-0 p-6 w-full">
                  <p className="text-xs tracking-[0.2em] uppercase text-[#FF2A2A] mb-2">{c.tagline}</p>
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-2xl uppercase tracking-tight">{c.name}</h3>
                    <ArrowRight className="w-5 h-5 text-white -translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
